import type { AnalysisRebuildStatus } from '../types';

function statusText(status: AnalysisRebuildStatus): string {
  switch (status.status) {
    case 'none': return 'No rebuild requested.';
    case 'queued': return 'Queued for rebuild.';
    case 'rebuilding': return `Rebuilding (${status.completed_days} of ${status.expected_days} days).`;
    case 'completed': return 'Rebuild completed.';
    case 'failed': return `Rebuild failed: ${status.latest_error ? `${status.latest_error.date}: ${status.latest_error.error_message}` : 'analysis failed'}`;
    case 'dispatch_failed': return `Rebuild dispatch failed for ${status.failed_dates.join(', ')}; use Save and rebuild again.`;
  }
}

export default function AnalysisRebuildStatusLine({ status, pollExpired, name }: {
  status: AnalysisRebuildStatus | null; pollExpired: boolean; name?: string;
}) {
  return status && <p role="status">{name && `${name}: `}{pollExpired
    ? 'Rebuild still running; reload to check.' : statusText(status)}</p>;
}
